module.exports = __webpack_public_path__ + "934f42a9eafe08079d3c3140eb64bde3.svg";